// // components/CustomNewMobileNumberChange.jsx
// import React, { useState } from 'react';
// import { Box, TextField, Button, Grid } from '@mui/material';

// const CustomNewMobileNumberChange = ({ formik }) => {
//   const [step, setStep] = useState('view'); // 'view', 'verifyOld', 'verifyNew'
//   const [oldOtpSent, setOldOtpSent] = useState(false);
//   const [newOtpSent, setNewOtpSent] = useState(false);
//   const [oldOtp, setOldOtp] = useState('');
//   const [newPhone, setNewPhone] = useState('');
//   const [newOtp, setNewOtp] = useState('');

//   const sendOldOtp = () => {
//     alert(`OTP sent to ${formik.values.email}`);
//     setOldOtpSent(true);
//   };

//   const verifyOldOtp = () => {
//     if (oldOtp === '123456') {
//       setStep('verifyNew');
//       setOldOtpSent(false);
//     } else {
//       alert('Invalid OTP for old email');
//     }
//   };

//   const sendNewOtp = () => {
//     alert(`OTP sent to ${newPhone}`);
//     setNewOtpSent(true);
//   };

//   const verifyNewOtp = () => {
//     if (newOtp === '654321') {
//       formik.setFieldValue('email', newPhone);
//       setNewPhone('');
//       setNewOtp('');
//       setStep('view');
//       setNewOtpSent(false);
//       alert('Phone successfully updated!');
//     } else {
//       alert('Invalid OTP for new email');
//     }
//   };

//   return (
//     <Box>
//       <Grid container spacing={2} alignItems="center">
//         <Grid item xs={8}>
//           <TextField
//             fullWidth
//             label="Phone"
//             name="email"
//             value={formik.values.email}
//             disabled
//           />
//         </Grid>
//         <Grid item xs={4}>
//           <Button
//             variant="outlined"
//             onClick={() => {
//               setStep('verifyOld');
//               sendOldOtp();
//             }}
//             disabled={step !== 'view'}
//           >
//             Edit
//           </Button>
//         </Grid>

//         {step === 'verifyOld' && (
//           <>
//             <Grid item xs={8}>
//               <TextField
//                 fullWidth
//                 label="Enter OTP (old email)"
//                 value={oldOtp}
//                 onChange={(e) => setOldOtp(e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={4}>
//               <Button variant="contained" onClick={verifyOldOtp}>
//                 Verify
//               </Button>
//             </Grid>
//           </>
//         )}

//         {step === 'verifyNew' && (
//           <>
//             <Grid item xs={8}>
//               <TextField
//                 fullWidth
//                 label="New Phone"
//                 value={newPhone}
//                 onChange={(e) => setNewPhone(e.target.value)}
//               />
//             </Grid>
//             <Grid item xs={4}>
//               <Button variant="outlined" onClick={sendNewOtp} disabled={!newPhone}>
//                 Send OTP
//               </Button>
//             </Grid>

//             {newOtpSent && (
//               <>
//                 <Grid item xs={8}>
//                   <TextField
//                     fullWidth
//                     label="Enter OTP (new email)"
//                     value={newOtp}
//                     onChange={(e) => setNewOtp(e.target.value)}
//                   />
//                 </Grid>
//                 <Grid item xs={4}>
//                   <Button variant="contained" onClick={verifyNewOtp}>
//                     Verify & Update
//                   </Button>
//                 </Grid>
//               </>
//             )}
//           </>
//         )}
//       </Grid>
//     </Box>
//   );
// };

// export default CustomNewMobileNumberChange;

// components/CustomNewMobileNumberChange.jsx





import React, { useEffect, useState } from 'react';
import { Grid, TextField, Button, InputAdornment } from '@mui/material';
import { Field } from 'formik';
import { useDispatch } from 'react-redux';
import actions from '../../ReduxStore/actions';
import { toast } from 'react-toastify';
import { CheckCircle } from '@mui/icons-material';

const CustomNewMobileNumberChange = ({ formik, name, label, value, setFieldValue, inputType, custPlaceholder, rest }) => {
    const [step, setStep] = useState('view');
    const [showSendOtp, setShowSendOtp] = useState(false)
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState('');
    const [newPhone, setNewPhone] = useState('');
    const [newOtpSent, setNewOtpSent] = useState(false);
    const [newOtp, setNewOtp] = useState('');
    const dispatch = useDispatch()
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [timer, setTimer] = useState(300); // 5 minutes in seconds
    const [otpValues, setOtpValues] = useState(["", "", "", ""]);

    const [isVerified, setIsVerified] = useState(false);




    const currentPhone = value;
    console.log(value, "currentPhone")

    // const sendOldOtp = () => {
    //     alert(`OTP sent to old email: ${currentPhone}`);
    //     setOtpSent(true);
    // };

    const verifyOldOtp = () => {
        // if (otp === '1234') {
        setStep('editNew');
        setOtpSent(false);
        setOtp('');
        // } else {
        //     alert('Invalid OTP for old email');
        // }
    };


    useEffect(() => {
        let countdown;
        if (isOtpSent && timer > 0) {
            countdown = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        } else if (timer === 0) {
            clearInterval(countdown);
        }
        return () => clearInterval(countdown);
    }, [isOtpSent, timer]);

    const sendNewOtp = () => {
        // alert(`OTP sent to new email: ${newPhone}`);
        setNewOtpSent(true);
    };

    const verifyNewOtp = () => {
        if (newOtp === '654321') {
            setFieldValue(name, newPhone);
            setStep('view');
            setNewPhone('');
            setNewOtp('');
            setNewOtpSent(false);
            alert('Phone updated successfully!');
        } else {
            alert('Invalid OTP for new email');
        }
    };


    const handleSendOtpApi = async (phone) => {
        // console.log("3333333handlesend");
        // const data2 = {
        //     data: {
        //         personal_email: value,
        //     },
        //     method: "post",
        //     apiName: "register/checkUserExistForPhoneRegister",
        // };
        // const verifyPhone = await dispatch(
        //     actions.CHECKCUSTOMEREXISTFOREMAILREGISTER(data2)
        // );

        // if (verifyPhone?.payload?.message === "Success") {
        // const data1 = {
        //     data: {
        //         email: email,
        //     },
        //     method: "post",
        //     apiName: "sendOTP",
        // };
        // dispatch(actions.EMAILSENDOTP(data1));
        // Check if phone number is exactly 10 digits
        const isValidPhone = /^\d{10}$/.test(phone);
        if (!isValidPhone) {
            toast.error("Please enter a valid 10-digit phone number");
            // return;
        }
        if (isValidPhone) {
            setStep('verifyOld')

            setIsOtpSent(true);
            // setNewOtpSent(tru)
            setTimer(300); // Reset timer to 5 minutes
            toast.success("OTP send Successfully");
        }
        if(isValidPhone && newPhone){
            setNewOtpSent(true)
        }
        // } else {
        //     toast.error(verifyPhone?.payload?.message);
        // }
    };


    const handleSendOtp = (email) => {
        // if (emailInput.trim() === "") {
        //     // alert("Please enter a valid email.");
        //     toast.error("Please enter a email.");
        //     return;
        // }
        handleSendOtpApi(email);
    };
    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? `0${secs}` : secs}`;
    };

    const handleResend = (email) => {
        setTimer(60); // Reset the timer to 60 seconds (or your desired duration)
        handleSendOtp(email); // Function to resend the OTP
    };


    const handleOtpChange = (index, value) => {
        if (/[^0-9]/.test(value)) return; // Allow only numbers

        const updatedOtp = [...otpValues];
        updatedOtp[index] = value;
        setOtpValues(updatedOtp);

        if (value && index < otpValues.length - 1) {
            document.getElementById(`otp-${index + 1}`).focus();
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === "Backspace" && otpValues[index] === "") {
            if (index > 0) {
                document.getElementById(`otp-${index - 1}`).focus();
            }
        }
    };

    const handleVerify = async (email) => {
        const enteredOtp = otpValues.join("");
        const otp = Number(enteredOtp);
        // const data1 = {
        //     data: {
        //         email: email,
        //         otp: otp,
        //     },
        //     method: "post",
        //     apiName: "verifyOTP",
        // };
        // const verifyOtp = await dispatch(actions.EMAILVERIFYOTP(data1));
        // console.log(verifyOtp, "verifyOtpverifyOtp");

        if (otp === 1234) {
            // setIsVerified(true);
            toast.success("Old phone number has been verified.Enter new phone number")
            // setFieldValue(name, value); // Set Formik's email value
            // setFieldValue("isVerified", true); // Set Formik's isVerified field to true
            setIsOtpSent(false);
            setStep('editNew');
            setOtpSent(false);
            // setShowSendOtp(false)
            setOtpValues(["", "", "", ""]);
            setOtp('');
            // setOtpVerifiedError(false); // Clear error after successful verification
        } else {
            // setOtpVerifiedError(true); // Set error if OTP is incorrect
            toast.error("Incorrect OTP. Please try again.");
        }
    };


    const handleVerifyNewPhone = async (email) => {
        console.log(email, "emaillllllll")
        const enteredOtp = otpValues.join("");
        const otp = Number(enteredOtp);
        // const data1 = {
        //     data: {
        //         email: email,
        //         otp: otp,
        //     },
        //     method: "post",
        //     apiName: "verifyOTP",
        // };
        // const verifyOtp = await dispatch(actions.EMAILVERIFYOTP(data1));
        // console.log(verifyOtp, "verifyOtpverifyOtp");

        if (otp === 1234) {
            toast.success("OTP verified successfully")
            setIsVerified(true);
            setFieldValue(name, email); // Set Formik's email value
            setFieldValue("isVerified", true); // Set Formik's isVerified field to true
            setIsOtpSent(false);
            setNewOtpSent(false)
            // setStep('editNew');
            setOtpSent(false);
            setOtpValues(["", "", "", ""]);
            setOtp('');
            // setOtpVerifiedError(false); // Clear error after successful verification
        } else {
            // setOtpVerifiedError(true); // Set error if OTP is incorrect
            toast.error("Incorrect OTP. Please try again.");
        }
    };

    return (
        <Grid
            // container spacing={1}
            sx={{ width: "100%" }}
        >
            <div
                style={{ marginBottom: "5px", display: "flex", alignItems: "center" }}
            >
                <label
                    htmlFor={name}
                    className="input-heading12"
                    style={{ fontSize: "15px", fontWeight: "450", marginRight: "10px" }}
                >
                    {step === 'editNew' ? "New email" : label}
                    {/* {important && (
                            <FaStarOfLife
                                style={{ color: "#F53E5C", fontSize: "8px", marginLeft: "3px" }}
                            />
                        )} */}
                </label>
            </div>
            {step === 'view' && (
                <>
                    <Grid
                        // size={{ xs: 12 }}
                        style={{ position: "relative", width: "100%" }}>
                        {/* <TextField
                            fullWidth
                            label={label}
                            value={value}
                            disabled
                        /> */}
                        <Field
                            id={name}
                            name={name}
                            disabled
                            type={inputType || "text"}
                            placeholder={custPlaceholder || "Enter Phone"}
                            value={value} // Bind to emailInput state
                            // onChange={(e) => {
                            //     setPhoneInput(e.target.value); // Update local state
                            //     setFieldValue(name, e.target.value); // Update Formik's state
                            // }}
                            {...rest}
                            style={{
                                borderRadius: "3px",
                                width: "100%",
                                boxSizing: "border-box",
                                height: "35px",
                                paddingLeft: "10px",
                            }}
                            className="custominput-field12"
                        />
                        {/* </Grid> */}
                        {/* <Grid item xs={4}> */}
                        {!showSendOtp &&
                            <Button
                                style={{
                                    textTransform: "none",
                                    fontSize: "10px",
                                    position: "absolute",
                                    right: "10px",
                                    top: "5px",
                                    height: "25px",
                                    width: "70px",
                                    backgroundColor: "var(--main-color)",
                                    color: "white",
                                    borderRadius: "23px",
                                }}
                                variant="outlined"
                                fullWidth
                                onClick={() => {
                                    // setStep('verifyOld');
                                    // sendOldOtp();
                                    setShowSendOtp(true)
                                }}
                            >
                                Edit
                            </Button>
                        }
                        {showSendOtp &&
                            <Button

                                onClick={() => {
                                    // sendOldOtp();
                                    handleSendOtp(value)
                                }}

                                // handleSendOtp}
                                style={{
                                    textTransform: "none",
                                    fontSize: "10px",
                                    position: "absolute",
                                    right: "10px",
                                    top: "5px",
                                    height: "25px",
                                    width: "70px",
                                    backgroundColor: "var(--main-color)",
                                    color: "white",
                                    borderRadius: "23px",
                                }}
                            >
                                Send OTP
                            </Button>
                        }


                    </Grid>
                </>
            )}




            {step === 'verifyOld' && (
                <>
                    {/* <Grid item xs={8}>
                        <TextField
                            fullWidth
                            label="OTP to old email"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <Button variant="contained" fullWidth onClick={verifyOldOtp}>
                            Verify
                        </Button>
                    </Grid> */}
                    {isOtpSent && (
                        <Grid
                            size={{ xs: 12 }}
                        >
                            <>
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "5px",
                                        alignItems: "center",
                                        justifyContent: "space-around",
                                    }}
                                >
                                    {otpValues.map((value, index) => (
                                        <input
                                            key={index}
                                            id={`otp-${index}`}
                                            type="text"
                                            name="emailOtp"
                                            maxLength="1"
                                            value={value}
                                            onChange={(e) => handleOtpChange(index, e.target.value)}
                                            onKeyDown={(e) => handleKeyDown(index, e)}
                                            style={{
                                                borderRadius: "3px",
                                                width: "25%",
                                                height: "35px",
                                                textAlign: "center",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                            }}
                                        />
                                    ))}


                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                            justifyContent: "end",
                                            width: "100%",
                                        }}
                                    >
                                        {timer > 0 ? (
                                            <>
                                                <span
                                                    style={{
                                                        color: "#555",
                                                        fontSize: "10px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    Resend <span>{formatTime(timer)}</span>
                                                </span>

                                                <Button
                                                    onClick={() => {
                                                        handleVerify(value)
                                                    }}
                                                    // onClick={verifyOldOtp}


                                                    style={{
                                                        textTransform: "none",
                                                        fontSize: "10px",
                                                        height: "25px",
                                                        width: "70px",
                                                        backgroundColor: "var(--main-color)",
                                                        color: "white",
                                                        borderRadius: "23px",
                                                    }}
                                                >
                                                    Verify
                                                </Button>
                                            </>
                                        ) : (
                                            <Button
                                                // onClick={handleResend}
                                                style={{
                                                    textTransform: "none",
                                                    fontSize: "10px",
                                                    height: "25px",
                                                    width: "70px",
                                                    backgroundColor: "var(--main-color)",
                                                    color: "white",
                                                    borderRadius: "23px",
                                                }}
                                            >
                                                Resend
                                            </Button>
                                        )}
                                    </div>
                                </div>
                                {/* </div> */}
                            </>
                        </Grid>
                    )}
                </>
            )}

            {step === 'editNew' && (
                <>
                    {/* <Grid item xs={8}>
                        <TextField
                            fullWidth
                            label="New Phone"
                            value={newPhone}
                            onChange={(e) => setNewPhone(e.target.value)}
                        />
                    </Grid> */}
                    {!newOtpSent && !isVerified && (
                        <Grid
                            // size={{ xs: 12 }}
                            style={{ position: "relative", width: "100%" }}>
                            {/* <TextField
                            fullWidth
                            label={label}
                            value={value}
                            disabled
                        /> */}
                            <Field
                                id={name}
                                name={name}
                                // disabled
                                type={inputType || "text"}
                                placeholder={custPlaceholder || "Enter Phone"}
                                value={newPhone}
                                onChange={(e) => setNewPhone(e.target.value)}
                                // value={value} // Bind to emailInput state
                                // onChange={(e) => {
                                //     setPhoneInput(e.target.value); // Update local state
                                //     setFieldValue(name, e.target.value); // Update Formik's state
                                // }}
                                {...rest}
                                style={{
                                    borderRadius: "3px",
                                    width: "100%",
                                    boxSizing: "border-box",
                                    height: "35px",
                                    paddingLeft: "10px",
                                }}
                                className="custominput-field12"
                            />
                            {/* </Grid> */}
                            {/* <Grid item xs={4}> */}

                            {showSendOtp &&
                                <Button

                                    onClick={() => {
                                        // setStep('verifyOld')
                                        // sendOldOtp();
                                        handleSendOtp(newPhone)
                                        // sendNewOtp()

                                    }}
                                    // onClick={sendNewOtp}
                                    disabled={!newPhone}

                                    // handleSendOtp}
                                    style={{
                                        textTransform: "none",
                                        fontSize: "10px",
                                        position: "absolute",
                                        right: "10px",
                                        top: "5px",
                                        height: "25px",
                                        width: "70px",
                                        backgroundColor: "var(--main-color)",
                                        color: "white",
                                        borderRadius: "23px",
                                    }}
                                >
                                    Send OTP
                                </Button>
                            }


                        </Grid>
                    )}
                    {/* <Grid item xs={4}>
                        <Button
                            variant="outlined"
                            fullWidth
                            onClick={sendNewOtp}
                            disabled={!newPhone}
                        >
                            Send OTP
                        </Button>
                    </Grid> */}


                    {newOtpSent && (
                        <Grid
                            size={{ xs: 12 }}
                        >
                            <>
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "5px",
                                        alignItems: "center",
                                        justifyContent: "space-around",
                                    }}
                                >
                                    {otpValues.map((value, index) => (
                                        <input
                                            key={index}
                                            id={`otp-${index}`}
                                            type="text"
                                            name="emailOtp"
                                            maxLength="1"
                                            value={value}
                                            onChange={(e) => handleOtpChange(index, e.target.value)}
                                            onKeyDown={(e) => handleKeyDown(index, e)}
                                            style={{
                                                borderRadius: "3px",
                                                width: "25%",
                                                height: "35px",
                                                textAlign: "center",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                            }}
                                        />
                                    ))}


                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                            justifyContent: "end",
                                            width: "100%",
                                        }}
                                    >
                                        {timer > 0 ? (
                                            <>
                                                <span
                                                    style={{
                                                        color: "#555",
                                                        fontSize: "10px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    Resend <span>{formatTime(timer)}</span>
                                                </span>

                                                <Button
                                                    // onClick={verifyNewOtp}
                                                    onClick={() => {
                                                        handleVerifyNewPhone(newPhone)
                                                    }}


                                                    style={{
                                                        textTransform: "none",
                                                        fontSize: "10px",
                                                        height: "25px",
                                                        width: "70px",
                                                        backgroundColor: "var(--main-color)",
                                                        color: "white",
                                                        borderRadius: "23px",
                                                    }}
                                                >
                                                    Verify
                                                </Button>
                                            </>
                                        ) : (
                                            <Button
                                                onClick={() => {
                                                    handleResend(newPhone)
                                                }}
                                                style={{
                                                    textTransform: "none",
                                                    fontSize: "10px",
                                                    height: "25px",
                                                    width: "70px",
                                                    backgroundColor: "var(--main-color)",
                                                    color: "white",
                                                    borderRadius: "23px",
                                                }}
                                            >
                                                Resend
                                            </Button>
                                        )}
                                    </div>
                                </div>
                                {/* </div> */}
                            </>

                        </Grid>
                    )}
                    {isVerified && (
                        <div style={{ position: "relative" }}>
                            <Field
                                id={name}
                                name={name}
                                type={inputType || "text"}
                                value={newPhone} // Show the latest email input value
                                readOnly
                                style={{
                                    width: "100%",
                                    borderRadius: "3px",
                                    boxSizing: "border-box",
                                    height: "35px",
                                    paddingLeft: "10px",
                                }}
                                className="custominput-field12"
                            />
                            <InputAdornment
                                position="end"
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    color: "green",
                                }}
                            >
                                <CheckCircle />
                            </InputAdornment>
                        </div>
                    )}


                </>
            )}
        </Grid>
    );
};

export default CustomNewMobileNumberChange;
